import React, {
	createContext, useContext, useMemo, useRef,
} from 'react';

export const EventContext = createContext();

export const EventProvider = ({
	children,
	eventCallback,
	viewType,
	partnerId,
	onOptIn,
	onOptOut,
	onCustomMessage,
}) => {
	// Hold the latest callback identities in refs so the context value can stay
	// stable across re-renders without consumers ever invoking a stale closure.
	const eventCallbackRef = useRef(eventCallback);
	const onOptInRef = useRef(onOptIn);
	const onOptOutRef = useRef(onOptOut);
	const onCustomMessageRef = useRef(onCustomMessage);

	eventCallbackRef.current = eventCallback;
	onOptInRef.current = onOptIn;
	onOptOutRef.current = onOptOut;
	onCustomMessageRef.current = onCustomMessage;

	const returnValue = useMemo(() => ({
		eventCallback: (...args) => eventCallbackRef.current?.(...args),
		onOptIn: (...args) => onOptInRef.current?.(...args),
		onOptOut: (...args) => onOptOutRef.current?.(...args),
		onCustomMessage: (...args) => onCustomMessageRef.current?.(...args),
		viewType,
		partnerId,
	}), [viewType, partnerId]);

	return (
		<EventContext.Provider value={returnValue}>
			{children}
		</EventContext.Provider>
	);
};

export const useEventContext = () => {
	const context = useContext(EventContext);
	if (!context) {
		throw new Error('useEventContext must be used within a EventProvider');
	}
	return context;
};
